export default "__VITE_ASSET__445b88ed__"